var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"id":"stake"}},[(_vm.bsc.addr)?_c('el-container',[_c('el-main',[_c('StakeMain')],1)],1):_c('el-col',{staticClass:"info"},[_c('h2',[_vm._v(_vm._s(_vm.$t("look-info")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }